import { render, staticRenderFns } from "./OrderItemCard.vue?vue&type=template&id=49b6962e"
import script from "./OrderItemCard.vue?vue&type=script&lang=js"
export * from "./OrderItemCard.vue?vue&type=script&lang=js"
import style0 from "./OrderItemCard.vue?vue&type=style&index=0&id=49b6962e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports